import { Components } from "@mui/material";

const MuiTableHead: Components["MuiTableHead"] = {
  styleOverrides: {
    root: {
      color: "red"
    },
  },
};

export default MuiTableHead;
